import React from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import Button from "@material-ui/core/Button";
import Popover from "@material-ui/core/Popover";
import Wrapper from "../atoms/Wrapper";
import Link from "../atoms/Link";
import {
  PlaylistAdd,
  PlaylistAddCheck,
  DeleteOutlined,
  InfoOutlined,
} from "@material-ui/icons";
import { add_my_vtuber_list, remove_my_vtuber_list } from "../../actions/user";

const ButtonWrapper = styled(Wrapper)`
  margin: ${(props) => (props.margin ? props.margin : "0.4rem 0")};
  justify-content: flex-start;
`;

const PoppedTextWrapper = styled.div`
  padding: 0.8rem 1.4rem;
  max-width: 100vw;
  width: 21rem;
`;

const PoppedText = styled.div`
  padding: 0.5rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const AddMyListButton = (props) => {
  const [hover, set_hover] = React.useState(false);
  const dispatch = useDispatch();
  const { isSignedIn } = useSelector(
    (state) => state.reduxTokenAuth.currentUser
  );
  const { my_vtuber_list_items } = useSelector((state) => state.user);
  const [fake_enabled, set_fake_enabled] = React.useState(false);
  const [fake_state, set_fake_state] = React.useState(false);

  const my_list_max_size = 1000;

  React.useEffect(() => {
    const found = my_vtuber_list_items.find((item) => item.id === props.id);
    if (found) {
      set_fake_enabled(true);

      if (found.state === "add_success") {
        set_fake_state(true);
      } else if (found.state === "remove_success") {
        set_fake_state(false);
      }
    } else {
      set_fake_enabled(false);
    }
  }, [my_vtuber_list_items, props.id]);

  const handleRemove = (e) => {
    if (isSignedIn) {
      dispatch(remove_my_vtuber_list(props.id));
    } else {
      setAnchorEl(e.currentTarget);
    }
  };
  const handleAdd = (e) => {
    if (isSignedIn) {
      dispatch(add_my_vtuber_list(props.id));
    } else {
      setAnchorEl(e.currentTarget);
    }
  };
  const handleHover = (value) => () => {
    set_hover(value);
  };
  const size = props.size ? props.size : "small";

  const [anchorEl, setAnchorEl] = React.useState(null);
  const is_popped = Boolean(anchorEl);
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const is_added = fake_enabled ? fake_state : props.is_added;

  const remove_variant = size === "large" ? "text" : "text";
  const add_check_variant = size === "large" ? "outlined" : "text";
  const add_variant = size === "large" ? "contained" : "outlined";

  return (
    <ButtonWrapper
      onMouseEnter={handleHover(true)}
      onMouseLeave={handleHover(false)}
      margin={props.margin}
    >
      {is_added ? (
        <>
          {hover ? (
            <Button
              variant={remove_variant}
              color="secondary"
              size={size}
              onClick={handleRemove}
            >
              <DeleteOutlined
                style={
                  props.icon_size
                    ? {
                        width: props.icon_size,
                        height: props.icon_size,
                        marginRight: "0.2rem",
                      }
                    : { marginRight: "0.2rem" }
                }
              />
              マイリストから削除
            </Button>
          ) : (
            <Button
              variant={add_check_variant}
              color="primary"
              size={size}
              onClick={handleRemove}
            >
              <PlaylistAddCheck
                style={
                  props.icon_size
                    ? {
                        width: props.icon_size,
                        height: props.icon_size,
                        marginRight: "0.2rem",
                      }
                    : { marginRight: "0.2rem" }
                }
              />
              マイリストに追加済み
            </Button>
          )}
        </>
      ) : (
        <Wrapper>
          <Button
            variant={add_variant}
            color="primary"
            size={size}
            onClick={handleAdd}
          >
            <PlaylistAdd
              style={
                props.icon_size
                  ? {
                      width: props.icon_size,
                      height: props.icon_size,
                      marginRight: "0.2rem",
                    }
                  : { marginRight: "0.2rem" }
              }
            />
            マイリストに追加
          </Button>
        </Wrapper>
      )}
      <Popover
        id="popover"
        open={is_popped}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <PoppedTextWrapper>
          <PoppedText>
            <InfoOutlined
              style={{ marginRight: "0.5rem", color: "rgba(0, 0, 0, 0.54)" }}
            />
            {isSignedIn
              ? `マイリストにはVTuberを最大${my_list_max_size}人までしか追加できません。`
              : "ログインが必要です。"}
          </PoppedText>
          {isSignedIn ? (
            <></>
          ) : (
            <Link to="/login">
              <Button variant="outlined" color="primary">
                ログイン
              </Button>
            </Link>
          )}
        </PoppedTextWrapper>
      </Popover>
    </ButtonWrapper>
  );
};

export default React.memo(AddMyListButton);
